import React, { useState, useEffect } from 'react';
import BlockCanvas  from '../components/BlockSystem/BlockCanvas';
import  StatsSidebar  from '../components/StatsSidebar';
import WelcomeModal from '../components/Onboarding/WelcomeModal';
import OnboardingDevPanel from '../components/Onboarding/OnboardingDevPanel';
import { OnboardingProvider } from '../components/Onboarding/OnboardingSystem';


const Dashboard = ({ user }) => {
  const [showWelcome, setShowWelcome] = useState(false);

  // Check if user is new on component mount
  useEffect(() => {
    if (user?.id) {
      const hasSeenWelcome = localStorage.getItem(`banyan_welcome_seen_${user.id}`);
      const hasCompletedOnboarding = localStorage.getItem(`banyan_onboarding_completed_${user.id}`);
      
      // Show welcome if user hasn't seen it and hasn't completed onboarding
      if (!hasSeenWelcome && !hasCompletedOnboarding) {
        setShowWelcome(true);
      }
    }
  }, [user]);

  const closeWelcome = () => {
    setShowWelcome(false);
  };

  const showWelcomeModal = () => {
    setShowWelcome(true);
  };

  return (
    <OnboardingProvider user={user}>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-celadon-50/30 dark:from-gray-900 dark:to-gray-800">
        {/* Subtle help text positioned at viewport bottom left */}
        <div id="help-hint" className="fixed bottom-6 left-6 z-50">
          <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm border border-gray-200/50 dark:border-gray-700/50 rounded-xl px-4 py-2 shadow-lg">
            <p className="text-sm text-gray-600 dark:text-gray-400 font-medium">
              Press <kbd className="px-2 py-1 bg-gray-100 dark:bg-gray-700 rounded-md text-xs font-mono mx-1 border border-gray-200 dark:border-gray-600 dark:text-gray-300">
                /
              </kbd> to add blocks
            </p>
          </div>
        </div>

        {/* Full Width Container for Dashboard */}
        <div className="max-w-[1920px] mx-auto px-6 py-6">
          {/* Main Layout - Sidebar + Block Canvas */}
          <div className="flex gap-8">
            {/* Left Sidebar - Stats */}
            <div id="stats-sidebar" className="flex-shrink-0">
              <StatsSidebar user={user} />
            </div>

            {/* Right Content - Block Canvas */}
            <div className="flex-1 min-w-0 relative">
              {/* Block Canvas */}
              <div id="block-canvas" className="animate-fade-in">
                <BlockCanvas user={user} />
              </div>
            </div>
          </div>

          {/* Welcome Modal for New Users */}
          <WelcomeModal
            user={user}
            isOpen={showWelcome}
            onClose={closeWelcome}
          />

          {/* Development Panel for Testing Onboarding */}
          <OnboardingDevPanel 
            user={user}
            onShowWelcome={showWelcomeModal}
          />
        </div>
      </div>
    </OnboardingProvider>
  );
};

export default Dashboard; 